// extracted by mini-css-extract-plugin
export default {"textLeft":"global_textLeft__GTpNY","textCenter":"global_textCenter__yAvLt"};